import { Component, OnInit } from '@angular/core';

interface Customer {
  name: string;
  phoneNumber: string;
  address: string;
}

const CUSTOMERS = [{name: 'Mack Freemantle', phoneNumber: '373-943-9901', address: '7962 Golden Leaf Point'},
  {name: 'Coretta Smithson', phoneNumber: '497-840-6587', address: '92 Walton Park'},
  {name: 'Madge Joss', phoneNumber: '425-730-6862', address: '7 Carey Pass'},
  {name: 'Clarie McCrum', phoneNumber: '715-952-1899', address: '47 Jana Place'},
  {name: 'Grove Cory', phoneNumber: '673-949-3819', address: '20 Onsgard Circle'},
  {name: 'Salli Gimson', phoneNumber: '180-774-7759', address: '24 Mayfield Park'},
  {name: 'Payton Pace', phoneNumber: '789-138-4012', address: '35828 Barnett Trail'},
  {name: 'Stefa Tate', phoneNumber: '209-500-2501', address: '41 Mesta Point'},
  {name: 'Bastian Worlock', phoneNumber: '253-303-7059', address: '63 4th Alley'},
  {name: 'Mylo Nutbeem', phoneNumber: '544-410-2841', address: '048 Orin Hill'},
  {name: 'Jackquelin Gasparro', phoneNumber: '350-782-5719', address: '913 Quincy Avenue'},
  {name: 'Jacquette Ellins', phoneNumber: '167-743-0438', address: '8849 Northfield Pass'},
  {name: 'Quintina Hamelyn', phoneNumber: '520-571-4005', address: '26375 Johnson Plaza'},
  {name: 'Merridie Abeles', phoneNumber: '936-214-3891', address: '4352 Kennedy Drive'},
  {name: 'Leora Tuckey', phoneNumber: '694-914-1111', address: '653 Pleasure Terrace'},
  {name: 'Abrahan Leglise', phoneNumber: '372-755-0992', address: '0 Talmadge Point'},
  {name: 'Wylma Bonus', phoneNumber: '419-104-4048', address: '1104 Buhler Plaza'},
  {name: 'Mack Cackett', phoneNumber: '399-738-8229', address: '3 Melby Place'},
  {name: 'Carolin Hulland', phoneNumber: '266-772-0800', address: '0 Everett Road'},
  {name: 'Bethena Cruce', phoneNumber: '469-853-3291', address: '63445 Everett Way'},
  {name: 'Sari MacKintosh', phoneNumber: '860-112-5135', address: '4 Ilene Center'},
  {name: 'Shayne Draycott', phoneNumber: '862-983-9480', address: '9772 Starling Pass'},
  {name: 'Lothario Morison', phoneNumber: '872-830-5299', address: '43 Sutherland Parkway'},
  {name: 'Brandea Serginson', phoneNumber: '711-780-9929', address: '04026 Dapin Point'},
  {name: 'Dotti Pietz', phoneNumber: '155-968-0130', address: '0 Warrior Place'},
  {name: 'Clair Vigneron', phoneNumber: '871-719-8154', address: '3 Lake View Road'},
  {name: 'Christoffer Rawcliffe', phoneNumber: '378-305-9548', address: '4321 Warbler Alley'},
  {name: 'Madelina Speachley', phoneNumber: '867-650-6073', address: '64 Commercial Lane'},
  {name: 'Rudd Whates', phoneNumber: '210-166-5872', address: '744 Arrowood Trail'},
  {name: 'Kerby Bretton', phoneNumber: '604-582-0374', address: '40501 Waxwing Parkway'},
  {name: 'Ninette MacCard', phoneNumber: '815-380-6741', address: '47 Eastlawn Way'},
  {name: 'Dorita Uzielli', phoneNumber: '898-154-1435', address: '38166 Sunbrook Lane'},
  {name: 'Averil Sollime', phoneNumber: '718-307-5664', address: '836 Hoard Park'},
  {name: 'Reiko Ewert', phoneNumber: '850-898-6732', address: '2790 Rockefeller Center'},
  {name: 'Sonni Quick', phoneNumber: '545-547-2922', address: '863 Red Cloud Center'},
  {name: 'Bernardine Ollis', phoneNumber: '103-566-2714', address: '4521 Lake View Road'},
  {name: 'Corrie Merrgen', phoneNumber: '454-566-9881', address: '948 Hayes Pass'},
  {name: 'Alasdair Skittle', phoneNumber: '166-343-9892', address: '15 Service Avenue'},
  {name: 'Nealy Ollive', phoneNumber: '668-580-5413', address: '2877 7th Street'},
  {name: 'Evaleen Smitherham', phoneNumber: '741-506-5229', address: '10602 Ramsey Terrace'},
  {name: 'Riordan Weedall', phoneNumber: '272-393-3196', address: '07538 Kingsford Way'},
  {name: 'Bendix Vlasov', phoneNumber: '577-273-6648', address: '65 Lake View Pass'},
  {name: 'Jorry Spellesy', phoneNumber: '555-583-6584', address: '539 Commercial Crossing'},
  {name: 'Jaymie Lohden', phoneNumber: '440-551-8794', address: '89 Hagan Court'},
  {name: 'Hyacinthie Luby', phoneNumber: '812-596-8353', address: '653 Daystar Circle'},
  {name: 'Codie Raynes', phoneNumber: '240-505-1475', address: '7 Erie Crossing'},
  {name: 'Lesley Dalgarno', phoneNumber: '915-552-2667', address: '48714 Scoville Hill'},
  {name: 'Ephrem Thacke', phoneNumber: '847-743-4265', address: '05 Roxbury Street'},
  {name: 'Minnie Bartolic', phoneNumber: '729-935-6328', address: '778 Jana Trail'},
  {name: 'Gwyn Gallienne', phoneNumber: '238-960-0907', address: '9738 Bartillon Circle'}];

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css']
})
export class CustomersComponent implements OnInit {

  customerList: Customer[] = CUSTOMERS;
  p = 1;
  count = 6;

  constructor() { }

  ngOnInit() {

  }

}
